import './App.css';
import './Addon.css';
import Shopping from './components/Shopping';
import Footer from './Footer';
import Cakes from './components/Cakes';
import { useState } from 'react';
import Cart from './components/Cart';
import Navbar from './components/Navbar';

function App() {

  const [cart, setCart] = useState([]);
  const [show, setShow] = useState(true);
  const [warning, setWarning] = useState(false);

  const handleClick = (item) => {
	
	if(item.amount === item.amount) { // chk whether initial value is NaN
		item.amount =1;
		console.log("The count inside loop is" + item.amount)
	}
	console.log("The count is" + item.amount)

    let isPresent = false;
		cart.forEach((product)=>{
			if (item.id === product.id)
			isPresent = true;
		})
		if (isPresent){
			setWarning(true);
			setTimeout(()=>{
				setWarning(false);
			}, 2000);
			return ;
		}
    setCart([...cart, item])
  }

  const handleChange = (item, d) =>{
	console.log("the item count is " + item.amount)
		let ind = -1;
		cart.forEach((data, index)=>{
			if (data.id === item.id)
				ind = index;
		});
		const tempArr = cart;
		tempArr[ind].amount += d;
		
		
		if (tempArr[ind].amount === 0)
			tempArr[ind].amount = 1;
		setCart([...tempArr])
	}

  return (
    <>
    <Navbar size={cart.length} setShow={setShow} />
      {
        show ? <Shopping handleClick={handleClick} /> : <Cart cart={cart} setCart={setCart} handleChange={handleChange} />
      } 
	  {
		warning && <div className='warning'> Item already added to your Cart !!</div>
	  }
    <div>
      
      {/* <Cakes /> */}
      <Footer />
    </div> 
    </>   


  );
}

export default App;
